import { z } from "zod";

import { attemptResultsSchema } from "./attempt";
import { timestampSchema } from "./common";
import { childProfileSchema } from "./profile";
import {
  domainMasteryListSchema,
  rewardStateSchema
} from "./progress";

export const PROFILE_IMPORT_VERSION = 1;

export const profileImportPayloadSchema = z
  .strictObject({
    version: z.literal(PROFILE_IMPORT_VERSION),
    exportedAt: timestampSchema,
    profile: childProfileSchema,
    attempts: attemptResultsSchema,
    mastery: domainMasteryListSchema,
    rewards: rewardStateSchema
  })
  .superRefine((payload, context) => {
    payload.attempts.forEach((attempt, index) => {
      if (attempt.profileId !== payload.profile.id) {
        context.addIssue({
          code: "custom",
          path: ["attempts", index, "profileId"],
          message: "Imported attempts must belong to the imported profile"
        });
      }
    });
  });

export type ProfileImportPayload = z.infer<typeof profileImportPayloadSchema>;
